import { RouteComponentProps } from 'react-router';

export function questionIdFromParamsProps(
  props: RouteComponentProps<{
    readonly questionId: string;
  }>
): string {
  return props.match.params.questionId;
}

export function questionSetSlugFromParamsProps(
  props: RouteComponentProps<{
    readonly setSlug: string;
  }>
): string {
  return props.match.params.setSlug;
}

export function pubSlugFromParamsProps(
  props: RouteComponentProps<{
    readonly pubSlug: string;
  }>
): string {
  return props.match.params.pubSlug;
}
